import { Button, CircularProgress } from "@material-ui/core";
import { httpClient } from "api/httpClient";
import { useSimpleModalToggle } from "components/dialogs/useSimpleModal";
import { useTerminalsContext } from "contexts/TerminalsProvider";
import React, { useState } from "react";
import { Confirm, useNotify, useRefresh, useTranslate } from "react-admin";
import { useNotifyError } from "utils/notifiers/useNotifyError";

export const GenerateBySourceDocPalletsButton = ({ order, disabled }) => {
	const { open, handleOpen, handleClose } = useSimpleModalToggle();
	const notify = useNotify();
	const notifyError = useNotifyError();
	const translate = useTranslate();
	const refresh = useRefresh();
	const [loading, setLoading] = useState(false);
	const { data: terminals = {} } = useTerminalsContext();
	const isGenerationEnabled =
		!!terminals[order?.terminal_id]?.should_create_pallets_from_packing_list_doc;

	const handleGenerate = async () => {
		setLoading(true);
		try {
			await httpClient(`/orders/${order.id}/generate-pallets-by-source-doc`, {
				method: "POST",
			});

			handleClose();
			notify(translate("osfc.dialogs.generate-pallets-by-source-doc.success"), "success");
			refresh();
		} catch (error) {
			notifyError(error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<Button
				size="small"
				variant="contained"
				color="primary"
				disabled={disabled || loading || !isGenerationEnabled}
				onClick={handleOpen}
			>
				{loading && <CircularProgress size={18} thickness={2} style={{ marginRight: 8 }} />}
				{translate("osfc.buttons.generate-pallets-by-source-doc")}
			</Button>
			<Confirm
				isOpen={open}
				loading={loading}
				title={translate("osfc.dialogs.generate-pallets-by-source-doc.title")}
				content={translate("osfc.dialogs.generate-pallets-by-source-doc.content")}
				onConfirm={handleGenerate}
				onClose={handleClose}
				confirm="osfc.buttons.confirm"
			/>
		</>
	);
};
